import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ClearIcon from '@mui/icons-material/Clear';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Snackbar, Alert } from '@mui/material';
import UserIcon from '../Sidebar/icons/UserBlue';
import FeedbackModal from '../Modal/FeedbackModal/FeedbackModal';
import './styles.scss';
import IndicarParceriaModal from '../Modal/IndicarParceriaModal/IndicarParceriaModal';
import useUserSidebar from './useUserSidebarHook';

export default function UserSideBar({ userSideBarOpen, setUserSideBarOpen, escopoAcesso }) {
  const navigate = useNavigate();
  const [modalFeedback, setModalFeedback] = useState(false);
  const [modalParceria, setModalParceria] = useState(false);
  const { user, msgErro, alert, setAlert } = useUserSidebar();

  const DrawerList = (
    <Box role="presentation">
      <Box className="user-sidebar-header">
        <Grid container className="header-sidebar-container">
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
            <Box className="texto-header texto-negrito">Conta</Box>
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
            <Box>
              <Button className="btn-close" onClick={() => setUserSideBarOpen(false)}>
                <ClearIcon />
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Grid container className="user-container">
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
            <Box className="icone-user">
              <UserIcon className="icon-notificacao font-size-10" />
            </Box>
          </Grid>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
            <Box className="nome-user">{user && user.nome}</Box>
            <Box className="email-user">{user && user.email}</Box>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box className="box-plataforma">
            <Grid container className="plataforma-container">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box className="texto-header texto-negrito">Plataforma</Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} onClick={() => navigate('/favoritos')}>
          <Grid container className="cadastrar-empresa-container">
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Box className="icone-position">
                <StarBorderIcon />
              </Box>
            </Grid>
            <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
              <Box className="label-cadastrar-empresa">Marcados como favoritos</Box>
            </Grid>
          </Grid>
        </Grid>

        {escopoAcesso?.plataforma_oneshell?.componente['indicar-empresas'] && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} onClick={() => setModalParceria(true)}>
            <Grid container className="cadastrar-empresa-container">
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Box className="icone-position">
                  <PersonAddAltIcon />
                </Box>
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                <Box className="label-cadastrar-empresa">Indicar empresas</Box>
              </Grid>
            </Grid>
          </Grid>
        )}

        {escopoAcesso?.plataforma_oneshell?.componente['enviar-feedback'] && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} onClick={() => setModalFeedback(true)}>
            <Grid container className="cadastrar-empresa-container">
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Box className="icone-position">
                  <AnnouncementOutlinedIcon />
                </Box>
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                <Box className="label-cadastrar-empresa">Enviar feedback</Box>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid className="borda-topo" item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container className="cadastrar-empresa-container" onClick={() => navigate('/login')}>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Box className="icone-position">
                <LogoutOutlinedIcon />
              </Box>
            </Grid>
            <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
              <Box className="label-cadastrar-empresa">Sair</Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        open={alert ? true : false}
        autoHideDuration={5000}
        onClose={() => setAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setAlert(false)} severity="error" className="w-100">
          <span className="w-100 texto-semi-negrito font-1rem">{msgErro}</span>
        </Alert>
      </Snackbar>
    </Box>
  );

  return (
    <Drawer
      className="user-sidebar"
      open={userSideBarOpen}
      onClose={() => setUserSideBarOpen(false)}
      anchor="right"
    >
      {DrawerList}
      <FeedbackModal open={modalFeedback} onClose={() => setModalFeedback(false)} />
      <IndicarParceriaModal open={modalParceria} onClose={() => setModalParceria(false)} />
    </Drawer>
  );
}
